import * as React from "react";
export var QuestTaskInviteFriends = function (props) {
    var task = props.tasks;
    var list = task.map(function (value) {
        return React.createElement("div", { key: value.locaKey }, "QuestType inviteFriends NOT IMPLEMENTED");
    });
    return React.createElement("div", { key: "inviteFriends" }, list);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/QuestTaskInviteFriends.tsx
// module id = 2674
// module chunks = 3